var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "accordion" },
    _vm._l(_vm.model.data, function(category, index) {
      return _c(
        "div",
        { key: index },
        [
          _c(
            "b-card",
            { staticClass: "mb-1", attrs: { "no-body": "" } },
            [
              _c(
                "b-card-header",
                { staticClass: "p-1", attrs: { "header-tag": "header" } },
                [
                  _c(
                    "a",
                    {
                      directives: [{ name: "b-toggle", rawName: "v-b-toggle" }],
                      attrs: { href: "accordion-" + index, variant: "info" },
                      on: {
                        click: [
                          function($event) {
                            $event.preventDefault()
                          },
                          function($event) {
                            _vm.selectedAccordionIndex = index
                          }
                        ]
                      }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(category.name) +
                          " - (" +
                          _vm._s(category.knowledgeItemsCount) +
                          ") "
                      )
                    ]
                  )
                ]
              ),
              _c(
                "b-collapse",
                {
                  attrs: {
                    visible: _vm.isVisible(index),
                    id: "accordion-" + index,
                    accordion: "accordion-categories"
                  },
                  on: {
                    show: function($event) {
                      return _vm.onShow(category)
                    }
                  }
                },
                [
                  _c(
                    "b-card-body",
                    [
                      _c("Grid", {
                        ref: "grid-" + category.id,
                        refInFor: true,
                        attrs: {
                          service: _vm.service,
                          "fetch-on-mounted": false,
                          route_grid_path:
                            "/categories/" + category.id + "/items",
                          route_name: "/categories/" + category.id + "/items"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "actions",
                              fn: function(actions) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "flex flex-row gap-2" },
                                    [
                                      _c("feather-icon", {
                                        directives: [
                                          {
                                            name: "permission",
                                            rawName: "v-permission",
                                            value: "knowledge_items.detail",
                                            expression:
                                              "'knowledge_items.detail'"
                                          },
                                          {
                                            name: "tooltip",
                                            rawName: "v-tooltip.top",
                                            value: {
                                              content: "Detalhar",
                                              delay: { show: 100, hide: 100 }
                                            },
                                            expression:
                                              "{ content: 'Detalhar', delay: { show: 100, hide: 100 }}",
                                            modifiers: { top: true }
                                          }
                                        ],
                                        staticClass:
                                          "h-5 w-5 mb-1 mr-1 stroke-current text-warning",
                                        attrs: { icon: "EyeIcon" },
                                        on: {
                                          click: function($event) {
                                            return _vm.detail(actions.row.id)
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }